import Service from "../../services";

const addressModule = {
    namespaced: true,
    state: {
        provinces: [],
        districts: [],
        subDistricts: []
    },
    mutations: {
        SET_PROVINCES: (state, data) => {
            state.provinces = data;
        },
        SET_DISTRICTS: (state, data) => {
            state.districts = data;
        },
        SET_SUB_DISTRICTS: (state, data) => {
            state.subDistricts = data;
        }
    },
    actions: {
        setProvinces({ commit }) {
            Service.province.getProvinces().then(res => {
                commit("SET_PROVINCES", res);
            });
        },
        async setDistricts({ commit }, code) {
            await Service.district.getDistricts(code).then(res => {
                commit("SET_DISTRICTS", res);
            });
        },
        clearDistricts({ commit }) {
            commit("SET_DISTRICTS", []);
        },
        clearSubDistricts({ commit }) {
            commit("SET_SUB_DISTRICTS", []);
        },
        async setSubDistricts({ commit }, code) {
            await Service.subDistrict.getSubDistricts(code).then(res => {
                commit("SET_SUB_DISTRICTS", res);
            });
        }
    },
    getters: {
        getProvinces(state) {
            return state.provinces;
        },
        getDistricts(state) {
            return state.districts;
        },
        getSubDistricts(state) {
            return state.subDistricts;
        }
    }
};
export default addressModule;
